import React from 'react';
import {flexRender, Table} from '@tanstack/react-table';
import classnames from 'classnames';
import styles from './GridTable.module.scss';

export type GridTableProps<T> = {
  table: Table<T>,
  emptyLabel?: React.ReactNode,
  customClassname?: {
    container?: string,
    header?: string,
    row?: string,
  },
};

const GridTable = <T, >({
                          table,
                          emptyLabel,
                          customClassname = {}
                        }: GridTableProps<T>) => {
  return (
    <>
      <table className={classnames(styles.tableContainer, customClassname?.container)}>
        <thead className={classnames(styles.tableHead, customClassname?.header)}>
        {table.getHeaderGroups().map(headerGroup => (
          <tr key={headerGroup.id}>
            {headerGroup.headers.map(header => (
              <th key={header.id}>
                {header.isPlaceholder
                  ? null
                  : flexRender(
                    header.column.columnDef.header,
                    header.getContext()
                  )}
              </th>
            ))}
          </tr>
        ))}
        </thead>
        <tbody className={classnames(styles.tableBody, customClassname?.row)}>
        {table.getRowModel().rows.map(row => (
          <tr key={row.id}>
            {row.getVisibleCells().map(cell => (
              <td key={cell.id}>
                {flexRender(cell.column.columnDef.cell, cell.getContext())}
              </td>
            ))}
          </tr>
        ))}
        </tbody>
        <tfoot>
        {table.getFooterGroups().map(footerGroup => (
          <tr key={footerGroup.id}>
            {footerGroup.headers.map(header => (
              <th key={header.id}>
                {header.isPlaceholder
                  ? null
                  : flexRender(
                    header.column.columnDef.footer,
                    header.getContext()
                  )}
              </th>
            ))}
          </tr>
        ))}
        </tfoot>
      </table>
      {table.getRowModel().rows.length === 0 ? emptyLabel : null}
    </>
  );
};

export default GridTable;
